import { RegisterClass } from "../../../Misc/typeStore.js";
import { FlowGraphBlock } from "../../flowGraphBlock.js";
import { RichTypeAny } from "../../flowGraphRichTypes.js";
import { FlowGraphPathComponent } from "../../flowGraphPathComponent.js";
export class FlowGraphGetPropertyBlock extends FlowGraphBlock {
    constructor(config) {
        super(config);
        this.config = config;
        this.value = this.registerDataOutput("value", RichTypeAny);
        this.templateComponent = new FlowGraphPathComponent(config.path, this);
    }
    _updateOutputs(context) {
        const value = this.templateComponent.getProperty(context);
        this.value.setValue(value, context);
    }
    getClassName() {
        return FlowGraphGetPropertyBlock.ClassName;
    }
}
FlowGraphGetPropertyBlock.ClassName = "FGGetPropertyBlock";
RegisterClass(FlowGraphGetPropertyBlock.ClassName, FlowGraphGetPropertyBlock);
//# sourceMappingURL=flowGraphGetPropertyBlock.js.map